import React from 'react';
export function UrgencyBar() {
  return <div className="bg-gradient-to-r from-magenta via-purple-mid to-blue-electric py-3 px-5 text-center font-heading font-bold text-[0.95rem] tracking-[0.5px] animate-bar-pulse z-50 relative" data-id="element-291">
      🔥 Lanzamiento especial —{' '}
      <span className="bg-gold text-dark-bg py-[2px] px-[10px] rounded-full mx-2 text-[0.85rem]" data-id="element-292">
        21 días
      </span>{' '}
      para interrumpir el ciclo para siempre
    </div>;
}